/**
 * OFFICIAL_MATCH — Single Source of Truth for the VerseSport Preview.
 *
 * During PREVIEW_MODE, every module that surfaces match identity, sharing
 * URLs, OG images, leaderboards, timeline, momentum, pressure, support,
 * rewards, missions, profile, predictions, chat and oracle prompts MUST
 * derive its teams / flags / competition label from this constant instead
 * of hardcoding MEX, BRA, etc.
 *
 * Live values (score, minute, status) still flow through the simulation /
 * provider; only the immutable identity is pinned here.
 */
import { PREVIEW_MODE } from "@/lib/previewMode";

export const OFFICIAL_MATCH = {
  id: "mex-arg", // internal simulation id (kept to preserve roster/telemetry wiring)
  homeCode: "ESP",
  awayCode: "ARG",
  homeName: "España",
  awayName: "Argentina",
  homeFlag: "🇪🇸",
  awayFlag: "🇦🇷",
  homeColor: "#e11d48",
  awayColor: "#60a5fa",
  competition: "Final del Mundial",
  baselineMinute: 81,
} as const;

export function isOfficialMatchLocked(): boolean {
  return PREVIEW_MODE;
}

/**
 * Force team identity fields onto the OFFICIAL_MATCH when Preview is active.
 * Live score / minute / status are passed through unchanged.
 */
export function lockToOfficialMatch<T extends {
  homeCode?: string; awayCode?: string;
  homeName?: string; awayName?: string;
  homeFlag?: string; awayFlag?: string;
}>(input: T): T {
  if (!isOfficialMatchLocked()) return input;
  return {
    ...input,
    homeCode: OFFICIAL_MATCH.homeCode,
    awayCode: OFFICIAL_MATCH.awayCode,
    homeName: OFFICIAL_MATCH.homeName,
    awayName: OFFICIAL_MATCH.awayName,
    homeFlag: OFFICIAL_MATCH.homeFlag,
    awayFlag: OFFICIAL_MATCH.awayFlag,
  };
}